import type { TMessages } from '@/types/TMessages'

export const messages = {
  proteinOption: 'Протеин: не менее {value}%',
} satisfies TMessages
